import { NotificationsNone } from '@mui/icons-material'
import { Loading } from 'components'
import { translate } from 'locales'
import React, { useEffect, useState } from 'react'
import { findInfoByKey } from '../services'
import { IInfoContent } from '../types'
import * as S from './styles'

const INFO_KEY = 'financeiro_regras_pagamento'

const Information = () => {
  const [loading, setLoading] = useState(false)
  const [info, setInfo] = useState<IInfoContent | null>(null)

  useEffect(() => {
    findInfoByKey(INFO_KEY, setInfo, setLoading)
  }, [])

  return (
    <S.Section>
      {loading && <Loading title={translate('financial.loading')} />}

      <S.Header>
        <NotificationsNone />
        <h2>{info?.title ?? translate('financial.information.title')}</h2>
      </S.Header>

      {!loading && info && (
        <S.Grid>
          {info.blocks.map((block) => (
            <S.Item key={block.order}>
              <S.ItemHeader>
                <span className="item-number">{block.order}</span>
                <h3>{block.title}</h3>
              </S.ItemHeader>

              <p>{block.description}</p>
            </S.Item>
          ))}
        </S.Grid>
      )}

      {!loading && !info && (
        <S.EmptyState>{translate('financial.information.empty')}</S.EmptyState>
      )}
    </S.Section>
  )
}

export default Information
